const TERMINALS_CHART_VARIANTS = {
    STATUS: {
        green: {
            fill: 'hsl(var(--badge-green-bg))',
            text: 'hsl(var(--badge-green-text))'
        },
        orange: {
            fill: 'hsl(var(--badge-orange-bg))',
            text: 'hsl(var(--badge-orange-text))'
        },
        red: {
            fill: 'hsl(var(--badge-red-bg))',
            text: 'hsl(var(--badge-red-text))'
        },
        default: {
            fill: '#000000', text: '#000000'
        }
    }
};

export default TERMINALS_CHART_VARIANTS;